import {
  queryExpenseDepartmentDetailList,
  queryExpenseGrowRateData,
  queryExpenseItineraryAggregation,
  queryExpenseItinerarySeparate,
  queryPersonalDetailList,
} from '../services/index';

export default {
  namespace: 'businessTrip',
  state: {},
  effects: {
    /**
     * 部门报销增长率数据
     */
    *queryExpenseGrowRateData({ payload }, { call }) {
      const result = yield call(queryExpenseGrowRateData, payload);
      return result;
    },
    /**
     * 部门报销详情列表数据
     */
    *queryExpenseDepartmentDetailList({ payload }, { call }) {
      const result = yield call(queryExpenseDepartmentDetailList, payload);
      return result;
    },
    /**
     * 个人报销详情列表数据
     */
    *queryPersonalDetailList({ payload }, { call }) {
      const result = yield call(queryPersonalDetailList, payload);
      return result;
    },
    /**
     * 个人详细出差，行程聚合
     */
    *queryExpenseItineraryAggregation({ payload }, { call }) {
      const result = yield call(queryExpenseItineraryAggregation, payload);
      return result;
    },
    /**
     * 个人详细出差，行程拆分
     */
    *queryExpenseItinerarySeparate({ payload }, { call }) {
      const result = yield call(queryExpenseItinerarySeparate, payload);
      return result;
    },
  },

  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
